import {
    Box,
    Container,
    Grid,
    Typography
} from "@mui/material";

const presencia = [
    {
        estado: "E.U.A",
        municipios: [
            "Calexico",
            "Arizona",
        ]
    },
    {
        estado: "B.C. NORTE",
        municipios: [
            "Ensenada",
            "Tijuana",
            "Mexicali"
        ]
    },
    {
        estado: "B.C. SUR",
        municipios: [
            "Guerrero Negro",
            "Los Cabos",
        ]
    },
    {
        estado: "SONORA",
        municipios: [
            "Cd. Obregon",
        ]
    },
    {
        estado: "SINALOA",
        municipios: [
            "Guasave",
            "Culiacan",
            "Mazatlan"
        ]
    },
    {
        estado: "JALISCO",
        municipios: [
            "Guadalajara",
        ]
    },
    {
        estado: "CDMX",
        municipios: [
            "Cdmx",
        ]
    }
];

const Presentes = () => {
    return (
        <Box
            sx={{
                py: {
                    xs: 8,
                    md: 12,
                },
                backgroundColor: "#fff",
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    sx={{
                        textAlign: "center",
                        fontSize: {
                            xs: "2.5rem",
                            md: "4rem",
                        },
                        fontWeight: 300,
                        color: "#4e6b4d",
                        mb: 8,
                    }}
                >
                    PRESENTES EN
                </Typography>

                {presencia.map((item) => (
                    <Grid
                        container
                        key={item.estado}
                        sx={{
                            mb: 5,
                            alignItems: "flex-start",
                        }}
                    >
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography
                                sx={{
                                    color: "#ffd700",
                                    fontWeight: 700,
                                    fontSize: {
                                        xs: "1.4rem",
                                        md: "1.8rem",
                                    },
                                    textAlign: {
                                        xs: "center",
                                        md: "right",
                                    },
                                    pr: {
                                        md: 4,
                                    },
                                    mb: {
                                        xs: 2,
                                        md: 0,
                                    },
                                }}
                            >
                                {item.estado}
                            </Typography>
                        </Grid>

                        <Grid size={{ xs: 12, md: 8 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 2,
                                    justifyContent: {
                                        xs: "center",
                                        md: "flex-start",
                                    },
                                }}
                            >
                                {item.municipios.map((municipio) => (
                                    <Typography
                                        key={municipio}
                                        sx={{
                                            color: "#4e6b4d",
                                            fontSize: {
                                                xs: "1.1rem",
                                                md: "1.3rem",
                                            },
                                        }}
                                    >
                                        {municipio}
                                    </Typography>
                                ))}
                            </Box>
                        </Grid>
                    </Grid>
                ))}
            </Container>
        </Box>
    );
};

export default Presentes;